<script>
	import { nanoid } from "nanoid";

	export let id = nanoid(6);
	export let label = null;
	export let sublabel = null;
	export let value = null;
	export let maxlength = null;
	export let required = false;
	export let disabled = false;
	export let placeholder = null;
	export let height;
	export let className;
</script>

{#if label}
	<label class={className} for={id}>
		{label}

		{#if required}
			<span class="required">*</span>
		{/if}

		{#if sublabel}
			<div class="sublabel">{sublabel}</div>
		{/if}
	</label>
{/if}
<input
	{id}
	class={`form-control ${className}`}
	type="text"
	{required}
	{disabled}
	{placeholder}
	{maxlength}
	style={height ? `height:${height}px` : ""}
	bind:value
	on:change />

<style>
	.nestedLabel {
		margin-left: 62px !important;
		max-width: -webkit-fill-available;
	}
</style>
